import React, { useState } from 'react';
import { VERSION } from '../config/version';

const Login = ({ onLogin, onSwitchToSignup }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // Get API URL from environment or use default
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api.example.com';
      console.log('Login attempt - API URL:', apiUrl);
      console.log('Login attempt - username:', username);
      console.log('Login attempt - request body:', JSON.stringify({ username, password }));
      
      const requestHeaders = {
        'Content-Type': 'application/json',
      };
      console.log('Login attempt - request headers:', requestHeaders);
      
      const response = await fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify({ username, password }),
      });

      console.log('Login response status:', response.status);
      console.log('Login response ok:', response.ok);
      console.log('Login response headers:', Object.fromEntries(response.headers.entries()));

      if (response.ok) {
        const data = await response.json();
        console.log('Login success - data:', data);
        onLogin(data.user, data.token);
      } else {
        const responseText = await response.text();
        console.log('Login error - response text:', responseText);
        try {
          const errorData = JSON.parse(responseText);
          console.log('Login error - errorData:', errorData);
          setError(errorData.message || errorData.error || 'Login failed');
        } catch (e) {
          console.log('Login error - could not parse JSON:', e);
          setError('Login failed - invalid response');
        }
      }
    } catch (err) {
      console.log('Login catch error:', err);
      setError('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 relative">
      {/* Version number at top left */}
      <div className="absolute top-4 left-4 text-xs text-gray-400">
        {VERSION}
      </div>
      
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to {process.env.REACT_APP_DISPLAY_NAME || 'Chatbot'}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Access your personalized AI assistant
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="username" className="sr-only">
                Username
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="text-red-600 text-sm text-center">{error}</div>
          )}

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
            >
              {isLoading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>

          <div className="text-center">
            <button
              type="button"
              onClick={onSwitchToSignup}
              className="text-indigo-600 hover:text-indigo-500 text-sm"
            >
              Don't have an account? Sign up
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
